// @ts-ignore
import controllers from "./*_controller.ts";

export default controllers;
